import { render, staticRenderFns } from "./SettingsMobileView.vue?vue&type=template&id=b54ad0b0"
import script from "./SettingsMobileView.vue?vue&type=script&lang=js"
export * from "./SettingsMobileView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports